import { Controller } from "stimulus";
import {
  validEmail,
  validFileUpload,
  validIssueAndExpiresDate,
  validContactNumber,
} from "../services/field-validation_services";

export default class extends Controller {
  static targets = [
    "emailError",
    "issueDate",
    "expireDate",
    "issuedOnError",
    "expiresOnError",
    "passportError",
    "signatureError",
    "passportPhoto",
    "signatureImage",
    "cidCopyError",
    "cidCopyImage",
    "contactNoError",
  ];

  connect() {}

  validateEmail(event) {
    const message = validEmail(event.target.value) ? "" : "Invalid Email";
    this.emailErrorTarget.textContent = message;
  }

  validateIssueAndExpireDate() {
    const message = validIssueAndExpiresDate(
      this.issueDateTarget.value,
      this.expireDateTarget.value
    )
      ? ""
      : "Invalid Issued and Expires Date";
    this.issuedOnErrorTarget.textContent = message;
    this.expiresOnErrorTarget.textContent = message;
  }

  validatePassport(event) {
    const file = event.target.files[0];
    const display_path = document.getElementById("passport-path");
    const message = validFileUpload(file) ? "" : "Invalid Passport";
    this.passportErrorTarget.textContent = message;
    display_path.innerHTML = validFileUpload(file) ? file.name : "";
  }

  validateSignature(event) {
    const file = event.target.files[0];
    const display_path = document.getElementById("signature-path");
    const message = validFileUpload(file) ? "" : "Invalid Signature";
    this.signatureErrorTarget.textContent = message;
    display_path.innerHTML = validFileUpload(file) ? file.name : "";
  }

  validateCidCopy(event) {
    const file = event.target.files[0];
    const display_path = document.getElementById("cid-copy-path");
    const message = validFileUpload(file) ? "" : "Invalid CID Copy";
    this.cidCopyErrorTarget.textContent = message;
    display_path.innerHTML = validFileUpload(file) ? file.name : "";
  }

  validateContactNo(event) {
    const message = validContactNumber(event.target.value)
      ? ""
      : "Invalid Contact Number";
    this.contactNoErrorTarget.textContent = message;
  }
}
